import debounce from 'lodash/debounce';
import { Store } from 'react-notifications-component';
import { inBrowser } from './browserUtils.js';
/**
 * These popup utilities need {@link MaterialNotification} component to be somewhere inside the app.
 *
 * @module
 */

/** Creates a new notification on screen */

var createNotification = function createNotification(options) {
  if (!inBrowser()) return;
  Store.addNotification(Object.assign({
    title: "New Notification",
    type: "info",
    insert: "bottom",
    container: "bottom-left",
    animationIn: ["animated", "fadeIn"],
    animationOut: ["animated", "fadeOut"],
    dismiss: {
      duration: 4000,
      pauseOnHover: true,
      showIcon: true
    }
  }, options));
};
/** Renders error alert (debounced to limit errors on screen) */


var alertError = debounce(function () {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Oops, something went wrong :(";
  createNotification({
    title: "Error!",
    message: message,
    type: "danger",
    container: "top-center",
    insert: "top"
  });
}, 1000, {
  trailing: false,
  leading: true
});
/** Renders success alert */

var alertSuccess = function alertSuccess(message) {
  createNotification({
    type: "success",
    message: message,
    title: null
  });
};
/** Renders info alert */


var alertInfo = function alertInfo(message, title) {
  createNotification({
    type: "info",
    message: message,
    title: title
  });
};
/** Renders action alert - info alert with appropriate title and position */


var alertAction = function alertAction(message) {
  createNotification({
    container: "top-center",
    type: "info",
    message: message,
    title: "Action required"
  });
};
/** Renders warning alert */


var alertWarning = function alertWarning(message) {
  createNotification({
    container: "top-center",
    type: "warning",
    title: "Warning",
    message: message
  });
};

export { alertAction, alertError, alertInfo, alertSuccess, alertWarning, createNotification };